<template>
  <div class="edit">
    <div class="edit__content">
      <div class="edit__content--close">
        <div @click="closeEditBenefit">
          <font-awesome-icon icon="times" />
        </div>
      </div>
      <div class="edit__content--container">
        <div class="edit__content--container-image">
          <img src="./../../../assets/style/images/parcel.svg" alt="benefit" />
        </div>
        <div class="edit__content--container-text">Edit Transport Benefits</div>
        <div class="edit__content--container-form">
          <div class="edit__content--container-form-name">Name of Benefit:</div>
          <div class="edit__content--container-form-input">
            <input v-model.trim="formData.name" type="text" class="form__input--name" />
          </div>
          <div
            class="edit__content--container-form-remove"
            @click.prevent="removeBenefit()"
            v-show="!deleting"
          >
            <font-awesome-icon icon="trash-alt" />&nbsp; Remove Benefit
          </div>
          <div v-show="deleting" class="edit__content--container-form-remove">
            <BlueLoader />
          </div>
        </div>
        <div class="edit__content--container-form">
          <div class="edit__content--container-form-name">Benefit Worth:</div>
          <div class="edit__content--container-form-input">
            <input
              v-model.trim="formData.worth"
              @keyup="formatAmount"
              class="form__input--worth"
              type="text"
            />
            <div class="form__input--naira">&#8358;</div>
          </div>
          <div class="edit__content--container-form-remove"></div>
        </div>
        <div class="edit__content--container-form">
          <div class="edit__content--container-form-name">Benefit Frequency:</div>
          <div class="edit__content--container-form-input">
            <select class="form__input--freq" v-model.trim="formData.frequency">
              <option>One Time</option>
              <option>Weekly</option>
              <option>Monthly</option>
              <option>Annually</option>
            </select>
          </div>
          <div class="edit__content--container-form-remove"></div>
        </div>

        <div>
          <div class="error">
            <div v-if="serverErrors">
              <p v-for="(value, name, index) in serverErrors" :key="index">{{value[0]}}</p>
            </div>
            <p v-if="dataSaveError">{{dataSaveError}}</p>
          </div>
        </div>

        <div class="edit__content--container-btn">
          <div @click.prevent="updateBenefit()" v-show="!loading">Save Settings</div>
          <div v-show="loading">
            <WhiteLoader />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import WhiteLoader from "../../partials/white-loader";
import BlueLoader from "../../partials/blue-loader";
import * as types from "../../../store/constant";

export default {
  name: "EditBenefit",
  components: {
    WhiteLoader,
    BlueLoader
  },
  props: {
    benefit: {
      type: Object
    }
  },
  data() {
    return {
      formData: {},

      deleting: false,
      loading: false,

      serverErrors: null,
      dataSaveError: ""
    };
  },

  mounted() {
    this.formData = this.benefit;
  },

  methods: {
    closeEditBenefit() {
      this.$emit("closeBenefit");
    },

    getBenefitIcon() {
      this.fileName = this.$refs.benefit;
      this.file = this.$refs.benefit.files[0];
      const ext = this.fileName.value.split(".").pop();

      if (
        ext.toLowerCase().trim() === "png" ||
        ext.toLowerCase().trim() === "jpg"
      ) {
        if (this.file) {
          this.uploadedFile = true;
          this.uploadedFileName = this.fileName.value.split("\\").pop();
          this.previewImage = URL.createObjectURL(this.file);
        }
        return;
      }
      this.uploadedFile = false;
    },

    removeBenefit() {
      this.serverErrors = null;
      this.deleting = true;

      this.$http
        .delete(`${types.GET_OTHER_BENEFITS_API}/${this.benefit.id}`)
        .then(() => {
          this.deleting = false;
          this.$router.push("/benefits");
        })
        .catch(err => {
          this.deleting = false;
          if (err.response) {
            const message = err.response.data.message;
            if (typeof message === "object") {
              this.serverErrors = message;
            } else {
              this.dataSaveError = message;
            }
          }
        });
    },

    updateBenefit() {
      this.serverErrors = null;
      this.dataSaveError = "";

      if (
        !this.formData.name ||
        !this.formData.worth ||
        !this.formData.frequency
      ) {
        this.dataSaveError = "All the input fields are required.";
        return;
      }

      if (!this.formData.worth.replace(/,/g, "").match(/^[0-9]+$/)) {
        this.dataSaveError = "The benefit worth should be numbers only";
        return;
      }

      const formWorth = this.formData.worth.replace(/,/g, "");

      this.loading = true;
      this.$http
        .put(`${types.GET_OTHER_BENEFITS_API}/${this.benefit.id}`, {
          name: this.formData.name,
          frequency: this.formData.frequency,
          worth: formWorth
        })
        .then(() => {
          this.loading = false;
          this.$emit("closeBenefit", true);
        })
        .catch(err => {
          this.loading = false;
          if (err.response) {
            const message = err.response.data.message;
            if (typeof message === "object") {
              this.serverErrors = message;
            } else {
              this.dataSaveError = message;
            }
          }
        });
    },
    formatAmount() {
      if (+this.formData.worth.replace(/,/g, "")) {
        this.formData.worth = parseInt(
          this.formData.worth.replace(/,/g, ""),
          10
        )
          .toString()
          .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
      } else {
        this.formData.worth = this.formData.worth.substring(
          0,
          this.formData.worth.length - 1
        );
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.edit {
  position: fixed;
  top: 0;
  left: 0;
  min-width: 1000px;
  height: 100%;
  background-color: rgba(112, 112, 112, 0.71);
  padding: 82px 13.854vw 100px 13.854vw;
  overflow: auto;

  .error {
    margin-top: 10px;
    margin-bottom: 40px;
    text-align: center;
    color: red;
    font-size: 0.938vw;
    font-style: italic;
    p {
      margin: 0;
    }
    > div {
      padding-bottom: 10px;
    }
  }

  .edit__content {
    width: 72.292vw;
    margin: 10px auto;
    border-radius: 2px;
    background-color: #ffffff;
    padding: 50px 9.74vw 50px 9.74vw;

    .edit__content--close {
      overflow: hidden;

      > div {
        width: 20px;
        height: 20px;
        float: right;
        cursor: pointer;
      }
    }

    .edit__content--container {
      margin-top: 30px;

      .edit__content--container-image {
        width: 3.438vw;
        margin: auto;
      }

      .edit__content--container-text {
        font-size: 1.458vw;
        font-weight: 500;
        font-style: normal;
        font-stretch: normal;
        line-height: 1.43;
        letter-spacing: normal;
        text-align: center;
        color: #000000;
        margin: 30px 0;
      }

      .edit__content--container-form {
        display: flex;
        flex-direction: row;
        flex-wrap: nowrap;
        align-items: flex-start;
        justify-content: center;
        align-content: center;
        padding-left: 5.208vw;
        margin-bottom: 50px;

        .edit__content--container-form-name {
          width: 20%;
          font-size: 1.042vw;
          font-weight: 300;
          font-style: normal;
          font-stretch: normal;
          line-height: 1.25;
          letter-spacing: normal;
          text-align: left;
          color: #000000;
        }

        .edit__content--container-form-input {
          width: 60%;
          height: 40px;
          border: solid 1px #c7c7c7;
          background-color: #ffffff;
          overflow: hidden;
          position: relative;

          > .form__input--name {
            height: 40px;
            border: solid 1px #c7c7c7;
            background-color: #ffffff;
            border: 0;
            outline: 0;
            padding: 0 5px;
          }

          > .form__input--worth {
            height: 40px;
            border: solid 1px #c7c7c7;
            background-color: #ffffff;
            border: 0;
            outline: 0;
            padding: 0 5px;
            padding-left: 45px;
          }

          > .form__input--freq {
            height: 40px;
            border: solid 1px #c7c7c7;
            background-color: #ffffff;
            border: 0;
            outline: 0;
          }

          > .form__input--enrol {
            height: 40px;
            border: solid 1px #c7c7c7;
            background-color: #ffffff;
            border: 0;
            outline: 0;
          }

          > .form__input--naira {
            position: absolute;
            top: 0;
            left: 0;
            width: 40px;
            height: 40px;
            border-right: solid 1px #c7c7c7;
            background-color: #fafafa;
            display: flex;
            flex-direction: row;
            flex-wrap: nowrap;
            align-items: center;
            justify-content: center;
            align-content: center;
          }
        }

        .edit__content--container-form-employees {
          width: 60%;
          background-color: #ffffff;
          overflow: hidden;

          > div {
            width: 50%;
            float: left;
            margin-bottom: 20px;
            padding: 0 10px;

            > div {
              height: 46px;
              border-radius: 20px;
              border: solid 1px #c7c7c7;
              background-color: #ffffff;
              display: flex;
              flex-direction: row;
              flex-wrap: nowrap;
              align-items: center;
              justify-content: center;
              align-content: center;
              overflow: hidden;

              > .form__employees--name {
                width: 80%;
                font-size: 0.938vw;
                font-weight: normal;
                font-style: normal;
                font-stretch: normal;
                line-height: 2.22;
                letter-spacing: normal;
                text-align: center;
                color: #5099de;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
              }

              > .form__employees--close {
                width: 20%;
                text-align: center;
                font-size: 0.938vw;
                font-weight: normal;
                font-style: normal;
                font-stretch: normal;
                line-height: 2.22;
                letter-spacing: normal;
                color: #5099de;
                cursor: pointer;
              }
            }
          }
        }

        .edit__content--container-form-remove {
          width: 20%;
          font-size: 0.833vw;
          font-weight: normal;
          font-style: normal;
          font-stretch: normal;
          line-height: 1.67;
          letter-spacing: 0.54px;
          color: #f17d6b;
          text-align: center;
          cursor: pointer;
        }
      }

      .edit__content--container-btn {
        > div {
          width: 9.063vw;
          height: 40px;
          border-radius: 5px;
          background-color: #5099de;
          margin: auto;
          font-size: 0.781vw;
          font-weight: normal;
          font-style: normal;
          font-stretch: normal;
          line-height: 1.2;
          letter-spacing: normal;
          text-align: center;
          color: #ffffff;
          display: flex;
          flex-direction: row;
          flex-wrap: nowrap;
          align-items: center;
          justify-content: center;
          align-content: center;
          cursor: pointer;
        }
      }
    }
  }
}
</style>
